export const archives = $axios => ({
  create: viewId => $axios.$post(`/builder/views/${viewId}/archive`),
  delete: viewId => $axios.$delete(`/builder/views/${viewId}/archive`),
});
